'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createGossipRpc = void 0;
/**
 * Create a gossipsub RPC object
 * @param {Array<RPC.IMessage>} msgs
 * @param {Partial<RPC.IControlMessage>} control
 * @returns {IRPC}
 */

function createGossipRpc() {
  var msgs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var control = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return {
    subscriptions: [],
    msgs: msgs,
    control: Object.assign({
      ihave: [],
      iwant: [],
      graft: [],
      prune: []
    }, control)
  };
}

exports.createGossipRpc = createGossipRpc;